import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { AnimatePresence, motion } from 'framer-motion';
import { infoSVG } from '../../lib/allCustomSVGs';
import CustomSVGs from '../../ui/customSVGs/CustomSVGs';
import '../../styles/components/subPageContentHolder/taraChatInfoTooltip.scss';

const TaraChatInfoTooltip = () => {
  const { t } = useTranslation();
  const currentChat = useSelector((state: RootState) => state.chat.currentChat);
  const currentChatInfo = useSelector(
    (state: RootState) => state.chat.currentChatInfo
  );
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node)
      ) {
        setIsTooltipOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    };
    return date.toLocaleDateString('en-US', options);
  };

  const getMessageCount = (): number => {
    return currentChat?.chatMessages?.length || 0;
  };

  const toggleTooltip = () => {
    setIsTooltipOpen(!isTooltipOpen);
  };

  if (!currentChat) {
    return null;
  }

  return (
    <div
      ref={tooltipRef}
      onClick={toggleTooltip}
      className='taraChatInfoTooltip'
    >
      <div className='taraChatInfoTooltip__icon'>
        <CustomSVGs svg={infoSVG} />
      </div>

      <AnimatePresence>
        {isTooltipOpen && (
          <motion.div
            className='taraChatInfoTooltip__content'
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.2 }}
          >
            <div className='taraChatInfoTooltip__content--header'>
              <h4>{t('ChatInformation')}</h4>
            </div>

            <div className='taraChatInfoTooltip__content--body'>
              {/* <div className='taraChatInfoTooltip__content--item'>
                <span className='label'>{t('Started')}:</span>
                <span className='value'>
                  {formatDate(currentChat.chatStartedDate)}
                </span>
              </div> */}

              <div className='taraChatInfoTooltip__content--item'>
                <span className='label'>{t('ChatID')}:</span>
                <span className='value chat-id'>{currentChat.chatId}</span>
              </div>

              <div className='taraChatInfoTooltip__content--item'>
                <span className='label'>{t('TotalMessages')}:</span>
                <span className='value'>{getMessageCount()}</span>
              </div>

              {currentChatInfo?.chatTokenCount !== null && (
                <div className='taraChatInfoTooltip__content--item'>
                  <span className='label'>{t('TokensUsed')}:</span>
                  <span className='value'>
                    {currentChatInfo?.chatTokenCount.toLocaleString()}
                  </span>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TaraChatInfoTooltip;
